import { Outlet, Navigate, useLocation } from 'react-router-dom';
import React from 'react';
const AuthenticatedRoutes = () => {
  const userUUID = sessionStorage.getItem('userUUID');
  const key = sessionStorage.getItem('key');
  const subscriptionPlanDetail = sessionStorage.getItem('planDetail');
  const businessType = sessionStorage.getItem('businessType');
  const location = useLocation();
  const restrictedPaths = [
    '/dashboard',
    '/booking',
    '/enquiry',
    '/complaint',
    '/services',
    '/feedback',
    '/check-in',
    '/chat'
  ];
  let planDetail: any = {};
  if (key !== 'Vendor' && subscriptionPlanDetail) {
    planDetail = JSON.parse(subscriptionPlanDetail);
  }
  if (!userUUID) {
    return <Navigate to="/" />;
  }

  if (
    businessType !== 'Retail' &&
    planDetail &&
    !planDetail.status &&
    restrictedPaths.includes(location.pathname)
  ) {
    return <Navigate to="/subscription" />;
  }

  return <Outlet />;
  // return userUUID?<Outlet/>:<Navigate to="/"/>
};

export default AuthenticatedRoutes;
